export default __webpack_public_path__ + "static/media/hks3.c94ce52d.jpg";